import { FormPanelConfig } from '@juvare/alert-ui/ui/features/alerts/components/AlertWizard/types';
import { AlertWidgetConfigTypes } from '@juvare/alert-ui/ui/features/alerts/form-widgets';
import { DefaultFormWidgetConfigTypes } from '@juvare/common-form-ui/WidgetForm/types';
import { SxProps, Theme } from '@mui/material';
import { TFunction } from 'i18next';

export const getTexasWizardStep = (
    config: FormPanelConfig,
    t: TFunction<'healthAlerts'>,
): { label: string; formChildren: DefaultFormWidgetConfigTypes<AlertWidgetConfigTypes>[] } => {
    let rootSx: SxProps<Theme> = defaultLayoutRootSx;
    let childrenSx: SxProps<Theme>[] = defaultLayoutChildrenSx;
    if (config.mode === 'review') {
        rootSx = {};
        childrenSx = [{ pb: 2 }];
    }

    const formConfig: DefaultFormWidgetConfigTypes<AlertWidgetConfigTypes>[] = [
        {
            type: 'form.panel',
            key: '!categories',
            style: {
                layout: 'column',
                surface: 'level1',
            },
            children: [
                {
                    type: 'alert.customLayout',
                    key: '!customLayout',
                    rootSx: rootSx,
                    childrenSx: childrenSx,
                    children: [
                        {
                            type: 'form.content',
                            key: 'content',
                            template: {
                                content: `<div style="display: flex; align-items: center"> <span class="icon-list-alt grey-700"></span> <p style="font-size: 20px; padding-left: 16px" class="subtitle1">${t(
                                    'forms.priorityCollection.subHeader',
                                )}</p></div>`,
                            },
                        },
                        {
                            type: 'form.panel',
                            key: '!channelsPanel',
                            style: {
                                paddingLeft: 56,
                            },
                            children: [
                                {
                                    type: 'form.select',
                                    key: 'pcrCategory',
                                    label: t('forms.priorityCollection.category'),
                                    valueProvider: {
                                        type: 'category',
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                                {
                                    type: 'form.select',
                                    key: 'pcrSubCategory',
                                    label: t('forms.priorityCollection.subCategory'),
                                    valueProvider: {
                                        paramsFrom: '^pcrCategory',
                                        type: 'subCategory',
                                    },
                                    disabled: {
                                        whenNoValues: true,
                                    },
                                    validate: {
                                        required: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ];

    if (config.mode === 'edit') {
        formConfig.unshift({
            type: 'form.content',
            style: {
                paddingTop: 8,
            },
            key: 'content1',
            html: `<h3>${t('forms.priorityCollection.title')}</h3>`,
        });
    }
    return {
        label: t('forms.priorityCollection.title'),
        formChildren: formConfig,
    };
};

export const defaultLayoutRootSx: SxProps<Theme> = {
    display: {
        md: 'flex',
    },
    justifyContent: {
        md: 'space-between',
    },
};

export const defaultLayoutChildrenSx: SxProps<Theme>[] = [
    {
        width: {
            xl: '32%',
            lg: '38%',
            md: '34%',
        },
        ml: 1,
        mt: {
            lg: 0.3,
            md: 1,
        },
        pb: {
            md: 0,
            xs: 2,
        },
    },
    {
        width: {
            xl: '64%',
            lg: '57%',
            md: '59%',
        },
    },
];
